<div class="image-header-renderer" (click)="onSortRequested($event)" [title]="imageTitle()">
  @if (iconSrc()) {
    <svg-icon-sprite
      [src]="iconSrc()"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
    ></svg-icon-sprite>
  }
  @if (sortDirection() === 'asc') {
    <span class="ag-sort-ascending-icon">
      <span class="ag-icon ag-icon-asc" unselectable="on" role="presentation"></span>
    </span>
  }
  @if (sortDirection() === 'desc') {
    <span class="ag-sort-descending-icon">
      <span class="ag-icon ag-icon-desc" unselectable="on" role="presentation"></span>
    </span>
  }
</div>
